/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-06-15 10:10:20
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\layouts\IndexLayout\locales\zh-TW.ts
 */
export default {
  'index-layout.topmenu.userinfo': '個人信息',
  'index-layout.topmenu.logout': '退出',
  'index-layout.topmenu.notcertified': '未認證',
  'index-layout.topmenu.certifing': '認證中',
  'index-layout.topmenu.certified': '已認證',
  'index-layout.topmenu.certifiedfail': '認證失敗',

  'index-layout.menu.home': '首頁',
  'index-layout.menu.home.workplace': '工作臺',
  'index-layout.menu.home.custom-breadcrumbs': '自定義面包屑',
  'index-layout.menu.home.custom-breadcrumbs.liqingsong.cc': 'liqingsong.cc',
  'index-layout.menu.home.docs': '使用文檔',

  'index-layout.menu.component': '組件',
  'index-layout.menu.component.icon': '圖標',
  'index-layout.menu.component.icon.svg': 'IconSvg',
  'index-layout.menu.component.icon.font': 'IconFont',
  'index-layout.menu.component.editor': '編輯器',
  'index-layout.menu.component.editor.tui-editor': 'tui-editor',
  'index-layout.menu.component.editor.ckeditor': 'CKEditor',

  'index-layout.menu.pages': '頁面示例',
  'index-layout.menu.pages.list': '列表頁面',
  'index-layout.menu.pages.list.basic': '標淮列表',
  'index-layout.menu.pages.list.table': '表格列表',
  'index-layout.menu.pages.list.highly-adaptive-table': '高度自適應表格',
  'index-layout.menu.pages.list.search': '搜索列表',
  'index-layout.menu.pages.list.search.table': '查詢表格',
  'index-layout.menu.pages.form': '表單頁面',
  'index-layout.menu.pages.form.basic': '基礎表單',
  'index-layout.menu.pages.form.complex': '高級表單',
  'index-layout.menu.pages.detail': '詳情頁面',
  'index-layout.menu.pages.detail.basic': '基礎詳情',
  'index-layout.menu.pages.detail.module': '模塊詳情',
  'index-layout.menu.pages.detail.table': '表格詳情',

  'index-layout.menu.roles': '權限驗證',
  'index-layout.menu.roles.all': '用戶都有權限',
  'index-layout.menu.roles.user': 'Users有權限',
  'index-layout.menu.roles.test': 'Tests有權限',

  'index-layout.menu.roles.personal': '個人中心',
  'index-layout.menu.roles.personal.account': '賬號信息',
  'index-layout.menu.roles.account': '賬戶管理',
  'index-layout.menu.roles.account.query': '賬戶查詢',
  'index-layout.menu.roles.account.recharge': '充值清單',
  'index-layout.menu.roles.account.logistics': '物流單費用清單',
  'index-layout.menu.roles.logistics': '物流訂單管理',
  'index-layout.menu.roles.logistics.sku': 'SKU管理',
  'index-layout.menu.roles.logistics.erp': 'ERP绑定',
  'index-layout.menu.roles.logistics.query': '物流單查詢',
  'index-layout.menu.roles.logistics.collectbill': '攬收單管理',
  'index-layout.menu.roles.logistics.address': '地址設置',
};
